(function () {
  function initHatPage(root) {
    if (!root || root.dataset.hatReady === 'true') return;
    root.dataset.hatReady = 'true';
    document.body.classList.add('has-hat-product');

    function removeLegacyPreorderUI() {
      var preorderOverlay = document.getElementById('pp_overlay');
      var preorderCartTag = document.getElementById('pp-cart-tag');

      if (preorderOverlay) preorderOverlay.remove();
      if (preorderCartTag) preorderCartTag.remove();
    }

    removeLegacyPreorderUI();

    var preorderUiObserver = new MutationObserver(removeLegacyPreorderUI);
    preorderUiObserver.observe(document.body, { childList: true });

    var heroImage = root.querySelector('.hat-hero__image');
    var thumbnails = root.querySelectorAll('[data-hat-thumbnail]');

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        if (!heroImage) return;

        heroImage.removeAttribute('srcset');
        heroImage.removeAttribute('sizes');
        heroImage.src = thumbnail.dataset.imageUrl;
        heroImage.alt = thumbnail.dataset.imageAlt || '';

        thumbnails.forEach(function (item) {
          var isActive = item === thumbnail;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
    });

    var primaryButton = root.querySelector('[data-hat-native-purchase]');
    var nativeButtonTemplate = root.querySelector('[data-hat-native-button-content]');
    var nativeButtonMarkup = nativeButtonTemplate ? nativeButtonTemplate.innerHTML : '';
    var nativeButtonLabel = primaryButton ? primaryButton.dataset.hatNativeLabel : '';

    function restoreNativePurchase() {
      root.querySelectorAll('[data-native-pre-order-btn-added], #pp-native-btn-area').forEach(function (item) {
        item.remove();
      });

      primaryButton = root.querySelector('[data-hat-native-purchase]:not([data-native-pre-order-btn-added])');
      if (!primaryButton) return;

      primaryButton.style.removeProperty('display');
      primaryButton.removeAttribute('aria-haspopup');

      if (nativeButtonLabel && primaryButton.textContent.trim() !== nativeButtonLabel) {
        primaryButton.innerHTML = nativeButtonMarkup;
      }
    }

    if (primaryButton) {
      restoreNativePurchase();

      var purchaseObserver = new MutationObserver(restoreNativePurchase);
      purchaseObserver.observe(root, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['style', 'aria-haspopup', 'data-native-pre-order-btn']
      });

      root.addEventListener('click', function (event) {
        var purchaseButton = event.target.closest('[data-hat-native-purchase]');
        if (!purchaseButton || !purchaseButton.hasAttribute('data-native-pre-order-btn')) return;

        restoreNativePurchase();
        event.stopImmediatePropagation();
      }, true);
    }

    var repeatButton = root.querySelector('[data-hat-repeat-button]');
    if (primaryButton && repeatButton) {
      repeatButton.addEventListener('click', function () {
        var currentPrimaryButton = root.querySelector('[data-hat-native-purchase]');
        if (currentPrimaryButton && !currentPrimaryButton.disabled) currentPrimaryButton.click();
      });
    }

    var reveals = root.querySelectorAll('.hat-reveal');
    if (!reveals.length) return;

    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    reveals.forEach(function (item) { observer.observe(item); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hat-page]').forEach(initHatPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
